export default () => ({
  list: [],
  priority: {
    1: '高',
    2: '中',
    3: '低'
  },
  modalProposalPriority: {
    1: '高',
    2: '中',
    3: '低',
    5: '非表示',
  },
  modalTemplatePriority: {
    4: 'ランダム表示',
    5: '非表示',
  },
  repeat: {
    0: '繰り返しなし',
    1: '毎日',
    2: '毎週',
    3: '毎月',
    4: '四半期ごと',
    5: '毎年'
  },
  listTags: []
})
